/*
 * @Description  :
 * @Version      : 1.0.0
 * @Author       : Luoye
 * @Date         : 2024-06-03 17:03:07
 * @LastEditors  : Luoye
 * @FilePath     : /partner_web/src/views/pc/index.tsx
 * Copyright (C) 2024 rose. All rights reserved.
 */
import React, { lazy, Suspense } from 'react';
import { createHashRouter, RouterProvider, Navigate } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import LoadingBox from 'SRC/common/components/message/components/LoadingBox';
import PageErrorBoundary from 'SRC/common/components/PageErrorBoundary';
import RouteRequireAuth from 'SRC/common/components/RouteRequireAuth';
import 'katex/dist/katex.min.css';
import 'SRC/static/styles/reset.scss';
const Index = lazy(
  () => import(/* webpackChunkName: "Index" */ './pages/IndexPage')
);
const LoginPage = lazy(
  () => import(/* webpackChunkName: "LoginPage" */ './pages/loginPage')
);
const Permission = lazy(
  () => import(/* webpackChunkName: "LoginPage" */ './pages/Permission')
);
const DigitBook = lazy(
  () => import(/* webpackChunkName: "LoginPage" */ './pages/DigitBook')
);
const ToolsCenter = lazy(
  () => import(/* webpackChunkName: "LoginPage" */ './pages/ToolsCenter')
);
const UserManage = lazy(
  () => import(/* webpackChunkName: "LoginPage" */ './pages/UserManage')
);
const DcoumentSearch = lazy(
  () => import(/* webpackChunkName: "LoginPage" */ './pages/DocumentSearch')
);
const OrgExerciseCheck = lazy(
  () => import('./pages/Exercise/components/OrgExerciseCheck')
);

const ExerciseProgress = lazy(
  () => import('./pages/Exercise/components/ExerciseProgress')
);

const ContentCreateSite = lazy(
  () =>
    import(
      /* webpackChunkName: "ContentCreateSite" */ './pages/AiZuowen/ContentCreateSite/index'
    )
);
// const IntelligentAgentManage = lazy(
//   () =>
//     import(
//       /* webpackChunkName: "IntelligentAgentManage" */ './pages/AiZuowen/IntelligentAgentManage/index'
//     )
// );
const AIProductManage = lazy(
  () =>
    import(
      /* webpackChunkName: "AIProductManage" */ './pages/AIProduct/ProductManage/index'
    )
);
const CreateProductData = lazy(
  () =>
    import(
      /* webpackChunkName: "CreateProductData" */ './pages/AIProduct/CreateProductData/index'
    )
);

const LazyLoad = (
  Component: React.LazyExoticComponent<React.FC<any>>,
  requireAuth: boolean
) => {
  return (
    <>
      {requireAuth ? (
        <Suspense fallback={<LoadingBox content="加载中..." />}>
          <RouteRequireAuth>
            <Component />
          </RouteRequireAuth>
        </Suspense>
      ) : (
        <Suspense fallback={<LoadingBox content="加载中..." />}>
          <Component />
        </Suspense>
      )}
    </>
  );
};

const container = document.getElementById('app');
if (container) {
  const router = createHashRouter([
    {
      path: '/',
      element: <Navigate to="/index" />,
      errorElement: <PageErrorBoundary />,
    },
    {
      path: '/index',
      element: LazyLoad(Index, true),
      children: [
        {
          path: 'permission',
          element: LazyLoad(Permission, false),
        },
        {
          path: 'user-manage',
          element: LazyLoad(UserManage, false),
        },
        {
          path: 'digit_book',
          element: LazyLoad(DigitBook, false),
        },
        {
          path: 'tools_center',
          element: LazyLoad(ToolsCenter, false),
        },
        {
          path: 'document-search',
          element: LazyLoad(DcoumentSearch, false),
        },
        {
          path: 'exercise-check',
          element: LazyLoad(OrgExerciseCheck, false),
        },
        {
          path: 'exercise-progress',
          element: LazyLoad(ExerciseProgress, false),
        },
        {
          path: 'content-create-site',
          element: LazyLoad(ContentCreateSite, false),
        },
        // {
        //   path: 'intelligent-agent-manage',
        //   element: LazyLoad(IntelligentAgentManage, false),
        // },
        {
          path: 'ai-product-manage',
          element: LazyLoad(AIProductManage, false),
        },
        {
          path: 'create-product-data',
          element: LazyLoad(CreateProductData, false),
        },
      ],
    },
    {
      path: '/login',
      element: LazyLoad(LoginPage, true),
    },
  ]);

  createRoot(container).render(
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
}
